<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="fornecedores"
      class="elevation-0 mt-5"
      :loading="loading"
      hide-default-footer
      :server-items-length="fornecedores.length"
      no-data-text="Nenhum fornecedor encontrado"
      loading-text="Carregando fornecedores..."
    >
      <template v-slot:item.codigoInterno="{ item }">
        <px-fornecedor-codigo-referencia small
                                         :icon-size="15"
                                         :fornecedor="item"
                                         @update="onUpdate"/>
      </template>
      <template v-slot:item.nome="{ item }">
        {{ nomeFornecedor(item) }}
      </template>
      <template v-slot:item.cnpj="{ item }">
        <px-fornecedor-documento :fornecedor="item.fornecedor"/>
      </template>
      <template v-slot:item.situcacao="{ item }">
        <px-ativo :ativo="!item.fornecedor.disabled"/>
      </template>
      <template v-slot:item.homologado="{ item }">
        <v-switch dense
                  hide-details
                  class="pa-0 pl-4 pb-2"
                  label=""
                  color="primary"
                  @change="onChangeHomologado($event, item)"
                  v-model="item.homologado"/>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon @click="onRemoveItem(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import FornecedorCodigoReferencia from './FornecedorCodigoReferencia.vue';

export default {
  props: {
    loading: Boolean,
    fornecedores: Array,
    default: [],
  },
  data() {
    return {
      headers: [
        {
          text: 'Código de referência',
          value: 'codigoInterno',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'nome',
          sortable: false,
        },
        {
          text: 'Documento',
          value: 'cnpj',
          sortable: false,
        },
        {
          text: 'Situação',
          value: 'situcacao',
          sortable: false,
        },
        {
          text: 'Homologado',
          value: 'homologado',
          sortable: false,
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    documento() {
      return fornecedor => (fornecedor.pessoa.documento
        ? fornecedor.pessoa.documento : fornecedor.pessoa.cnpj);
    },
    nomeFornecedor() {
      return fornecedorProduto => fornecedorProduto.nomeInternoFornecedor
        || fornecedorProduto.fornecedor.pessoa.nome;
    },
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    onChangeHomologado(event, item) {
      this.$emit('change-homologado', item);
    },
    onRemoveItem(item) {
      this.$refs.confirm
        .open(
          'Você deseja remover o fornecedor do produto?',
          'O fornecedor será removido e esta operação não pode ser desfeita.',
          { width: 450 },
        )
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$emit('remove', item);
        });
    },
  },
  components: {
    PxFornecedorCodigoReferencia: FornecedorCodigoReferencia,
  },
};
</script>
